// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"322":"f33016d3","639":"c3ac4da9","947":"85bc3186"}[chunkId] + ".chunk.js";
};